import { gql } from '@apollo/client'
import { MarketplaceItemStatusEnum, MarketplaceItemTypeEnum } from '@appTypes/MarketplaceTypes'

interface PaymentToken {
  id: string
  decimals: number
  symbol: string
}

interface Collection {
  id: string
  name: string
  symbol: string
}

interface Target {
  id: string
  boxItemCount: number | null
  tokenId: string
  tokenURI: string
  collection: Collection
}

export interface MarketplaceItemByTargetQueryVars {
  target: string
  seller?: string
}

export interface MarketplaceItemByTargetQueryData {
  marketItems: MarketplaceItem[]
}

interface MarketplaceItem {
  amount: string
  cutoff?: number
  id: string
  extra: string
  name: string
  paymentToken: PaymentToken
  reservePrice: string
  totalSupply: string
  vaultBalance: string
  fractionsCount: string
  symbol: string
  decimals: number
  released: boolean
  seller: string
  status: MarketplaceItemStatusEnum
  target: Target
  timestamp: number
  type: MarketplaceItemTypeEnum
  usersCount: number
}

export const MARKETPLACE_ITEM_BY_TARGET_AND_SELLER_QUERY = gql`
  query GetMarketplaceItemByTarget($target: String, $seller: String!) {
    marketItems(skip: 0, first: 1, where: { target: $target, seller_contains: $seller }) {
      amount
      cutoff
      id
      name
      extra
      paymentToken {
        id
        symbol
        decimals
      }
      reservePrice
      seller
      status
      target {
        id
        boxItemCount
        collection {
          id
        }
        tokenId
        tokenURI
      }
      timestamp
      type
      usersCount
    }
  }
`

export const MARKETPLACE_ITEM_BY_TARGET_QUERY = gql`
  query GetMarketplaceItemByTarget($target: String, $seller: [String!]) {
    marketItems(skip: 0, first: 1, where: { target: $target }) {
      amount
      cutoff
      id
      name
      extra
      paymentToken {
        id
        symbol
        decimals
      }
      reservePrice
      seller
      status
      target {
        id
        boxItemCount
        collection {
          id
        }
        tokenId
        tokenURI
      }
      timestamp
      type
      usersCount
    }
  }
`
